import { Col, Container, Nav, Row, Tab } from "@themesberg/react-bootstrap";

import CalibrationHistory from "./CalibrationHistory";
import FieldIssueHistory from "./FieldIssueHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faUser } from "@fortawesome/free-regular-svg-icons";

export default () => {
  return (
    <article>
      <Container className="px-0">
        <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
          <Col className="d-block mb-4 mb-md-0">
            <h5 className="head mb-4">Services Reports View</h5>
          </Col>
        </Row>
        <div>
          <Tab.Container defaultActiveKey="fieldIssueHistory">
            <Row>
              <Col lg={12}>
                <Nav fill variant="pills" className="flex-column flex-sm-row">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="fieldIssueHistory"
                      className="mb-sm-3 mb-md-0"
                    >
                      <FontAwesomeIcon icon={faUser} className="me-2" />
                      Field Job History
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="dispatchDealer"
                      className="mb-sm-3 mb-md-0"
                    >
                      <FontAwesomeIcon icon={faUser} className="me-2" />
                      Calibration History
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="fieldIssueHistory" className="py-4">
                    <FieldIssueHistory />
                  </Tab.Pane>
                  <Tab.Pane eventKey="dispatchDealer" className="py-4">
                    <CalibrationHistory />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </Container>
    </article>
  );
};